import React from 'react';
import { Typography } from '@wds/typography';
import { Box } from '@wds/box';
import { TabletScreen } from '@sm/webassets/MediaComponents';
import HeroFormCTA, { Props as HeroFormCTAProps } from '~app/components/HeroFormCTA';

import useStyles from './useStyles';

export type Props = {
  /** Header color (default `dark`) */
  color?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'upgrade'
    | 'info'
    | 'muted'
    | 'dark'
    | 'light'
    | 'darkMuted'
    | 'lightMuted'
    | 'link'; // TODO: use `TypographyProps['colors']` once Webassets use latest wrench version
  boldHeader: string;
  subHeader: string;
  formCopy: Omit<HeroFormCTAProps, 'className'>;
};

const HeroFormCallout = ({ color, boldHeader, subHeader: subHeaderContent, formCopy }: Props): React.ReactElement => {
  const { wrapper, image, ctaForm, header, subHeader, bold } = useStyles();
  return (
    <Box display="flex" flexJustify="center" flexDirection="column" data-testid="HeroFormCallout" className={wrapper}>
      <Box className={header}>
        <Typography component="section" variant="sectionTitle" color={color}>
          <span className={bold}>{boldHeader}</span>
        </Typography>
        <Box pt={3} className={subHeader}>
          <Typography component="div" variant="body" color={color}>
            {subHeaderContent}
          </Typography>
        </Box>
      </Box>
      <Box display="flex">
        <HeroFormCTA className={ctaForm} {...formCopy} />
        <TabletScreen>
          <div className={image} />
        </TabletScreen>
      </Box>
    </Box>
  );
};

export default HeroFormCallout;
